import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/eduegoo/frontend/app/courses/CoursesPage.tsx");
